import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { Badge } from "@/components/ui/badge";
import { listMyPurchaseOrders } from "@/lib/vendor-portal.functions";

export const Route = createFileRoute("/vendor/purchase-orders/")({
  component: POList,
});

function POList() {
  const fn = useServerFn(listMyPurchaseOrders);
  const { data, isLoading } = useQuery({ queryKey: ["vendor", "pos"], queryFn: () => fn({}) });
  const pos = data?.pos ?? [];

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold">Purchase Orders</h1>
      <div className="rounded-md border bg-card">
        {isLoading ? (
          <p className="p-4 text-sm text-muted-foreground">Loading…</p>
        ) : pos.length === 0 ? (
          <p className="p-4 text-sm text-muted-foreground">No POs issued to you yet.</p>
        ) : (
          <table className="w-full text-sm">
            <thead className="border-b bg-muted/40 text-xs uppercase text-muted-foreground">
              <tr>
                <th className="px-3 py-2 text-left">PO No.</th>
                <th className="px-3 py-2 text-left">Date</th>
                <th className="px-3 py-2 text-left">Expected Delivery</th>
                <th className="px-3 py-2 text-right">Total ₹</th>
                <th className="px-3 py-2 text-left">Status</th>
                <th className="px-3 py-2 text-left">Acknowledged</th>
                <th className="px-3 py-2"></th>
              </tr>
            </thead>
            <tbody>
              {pos.map((p: any) => (
                <tr key={p.id} className="border-b last:border-0">
                  <td className="px-3 py-2 font-medium">{p.po_number}</td>
                  <td className="px-3 py-2">{p.po_date}</td>
                  <td className="px-3 py-2">{p.expected_delivery_date ?? "—"}</td>
                  <td className="px-3 py-2 text-right">{Number(p.total_amount ?? 0).toLocaleString()}</td>
                  <td className="px-3 py-2"><Badge variant="outline">{p.status}</Badge></td>
                  <td className="px-3 py-2">
                    {p.acknowledged_at ? (
                      <Badge>Ack'd</Badge>
                    ) : (
                      <Badge variant="outline" className="border-amber-400 text-amber-700">Pending</Badge>
                    )}
                  </td>
                  <td className="px-3 py-2 text-right">
                    <Link to={"/vendor/purchase-orders/$poId" as any} params={{ poId: p.id } as any} className="text-primary hover:underline">View →</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
